"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
require("./App.css");
//@ts-ignore
const Project_1 = __importDefault(require("./components/Project")); // Remove @ts-ignore if types are resolved
//@ts-ignore
const Contact_1 = __importDefault(require("./components/Contact")); // Remove @ts-ignore if types are resolved
//@ts-ignore
// import SideChat from './components/SideChat'; // Import SideChat (adjust path if needed)
const react_1 = __importStar(require("react"));
function Header() {
    (0, react_1.useEffect)(() => {
        // GET request using fetch inside useEffect React hook
        fetch('https://212.2.245.17:3010/scanned')
            .then((response) => response.json())
            // .then((data) => setTotalReactPackages(data.total));
            .catch((error) => console.error('Fetch error:', error));
        // Empty dependency array means this effect will only run once
    }, []);
    return (react_1.default.createElement("div", { className: "bg-color-background-default text-white p-4 py-0 pb-0" },
        react_1.default.createElement("p", { className: "text-center text-5xl md:text-5xl lg:text-6xl bg-gray-300 text-black bold font-bold p-8 rounded-md" },
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: "text-3xl" },
                "Random videos I've liked or found charming over the decade. Wait 1 minute for videos to load. ",
                react_1.default.createElement("u", null, "Leave if you don't like weird."),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", { className: "text-sm" }),
                react_1.default.createElement("div", { className: "text-sm" }, "(Optional): Send me some videos.")))));
}
exports.Header = Header;
const projects = [
    // {
    //   title: '',
    //   youtube: 'yD2FSwTy2lw',
    //   body: `
    //   Welcome to my webpage. :^)
    //   `,
    // },
    {
        title: 'Medieval Fae Music',
        youtube: 'FykkW8EBvIg',
        body: `
    People in animal masks playing instruments in the woods. This musician (who lost their voice a decade ago) probably invented their own genre of music - with a mystical and fairylike feel. Honestly, the timeline where this bacame popular would have been really cool. See: Erutan for more info. My favorite example of their singing can be found in this video, animated by a fan of their voice. <a href="https://youtu.be/DWZ_ljipFkw?t=55">https://youtu.be/DWZ_ljipFkw?t=55</a>.
    `,
    },
    {
        title: "Summoning the Banana Man's spirit at 2AM",
        youtube: 'yModCU1OVHY',
        body: `
    A music video from a dead band from the 2000s. Not bad. Wish more people did weird things like this. More videos on their channel.
    `,
    },
    {
        title: 'Moon Lore',
        youtube: 'ELc4vlCIUWg',
        body: `
    This game has nice lore. I would recommend it. Especially if you like macabre and esoteric art.
    `,
    },
    {
        title: 'Lunacy Lore',
        youtube: 'Fi_rifEluDU',
        body: `
    A neat animation of a lunatic, related to the previous video. If you like both these videos, feel free to ask me for recommendations of lore channels.
    `,
    },
    {
        title: 'Ramen Rap',
        youtube: 'NUwcNtHtL_I',
        body: `
    Pink horse raps about ramen. Inspired by a a man named Pink Guy, a guy who wears a pink suit.
    `,
    },
    {
        title: '',
        youtube: '3dsycwPp6j8',
        body: `
    I've watched all this guy's videos - here's one of them. I recommend this channel a lot. None of the videos I've posted will help you in life, but THIS GUY has videos that MIGHT actually help you in life, and he has a good vibe.
    `,
    },
    {
        title: 'Psychological effects of Terraria modding',
        youtube: 'zu9OVFLFV9A',
        body: `
    A very good singer sings about their years modding terraria games I think. I don't mod terraria, but terraria mods are impressive. I found this video through this video here <a href="https://youtu.be/RPAjv7FGhd8?t=15">https://youtu.be/RPAjv7FGhd8?t=15</a>.
    `,
    },
    {
        title: '2.5 years of work in 1 animation',
        youtube: 'i7PQ9IO-7fU',
        body: `
    A song was once so good that a man spent 2.5 years making an animation for it. This is the animation for that song.
    `,
    },
    {
        title: 'If GMOD horror was Japanese MMD',
        youtube: '-CfWdvVJoyw',
        body: `
    I wish I understood japanese. Found this channel through a horror game lets play. They are somewhere between GMOD horror and MMD. Despite the horror, they are oddly madjestic - like in this video <a href="https://www.youtube.com/watch?v=dyWjym2y7o8">https://www.youtube.com/watch?v=dyWjym2y7o8</a>.
    `,
    },
    {
        title: 'Fan Animation of game',
        youtube: 'UNhphyF74sA',
        body: `
    This channel has a lot of animations about a game that takes place in dreams called yume nikki. I don't know what to think of it, but whoever makes these obviously put a lotta work and love into it. And a lot of people I've met over the years seem to somehow be also familiar with the game more than I am.
    `,
    },
    {
        title: '',
        youtube: 'S0t6aCsRKtY',
        body: `
    I don't really like this too much, but I did many years ago. And hey, we're on the topic of surrealism and dreams - so when in rome!
    `,
    },
    {
        title: '',
        youtube: 'YvFBjQofeGI',
        body: `
    This was a surreal horror trend a long time ago. If you haven't seen it, now you have.
    `,
    },
    {
        title: 'The Dementia Song',
        youtube: 'wJWksPWDKOc',
        body: `
    A playlist made by a man who had dementia to create music which embodies that dementia. Microtrend around 2020. Variations of this music for Minecraft songs can be found around the internet - used to induce a feeling of nostalgia, and these songs popped up in liminal horror, but I found no glory to these things. At least, not yet. Do not let this form of music consume you if you listen to it.
    `,
    },
    {
        title: '',
        youtube: 'UYKLGX9-_4Y',
        body: `
    A Russian fan animation of a game called S.T.A.L.K.E.R.
    `,
    },
    {
        title: 'Psychology of self collapsing civilization',
        youtube: 'NgGLFozNM2o',
        body: `
    A neat documentary about an experiment where a colony of rats, despite having all their food and shelter provided, somehow collapses to a population of 0 - purely through socialization? I think the guy who did this experiment was increasingly worried about the long term effects of urbanization across multiple generations on the human psyche. I think this guy also has a lecture on this <a href="https://www.youtube.com/watch?v=NpNCQ_gNqdE">https://www.youtube.com/watch?v=NpNCQ_gNqdE</a>. 

    <br><br>
    I often feel like one of the mice.
    `,
    },
    {
        title: '',
        youtube: '5iyxJ72G0lM',
        body: `
    <b> This song is obviously a joke.</b> I think the left and the right actually agree on the same things sometimes. For example, everybody is scared of Blackrock buying all the land / houses and not living in them. I hear they're buying electric companies, too. <br><br> I have a feeling that we are pawns arguing over social issues while those in power are fighting over tangible resources, because he who owns those resources gets to determine the prices. Social issues are the means by which we are used to fight amongst ourserlves and others, so that we do not look into securing true power.<br><br> Unlike most others, I am not too angry at elites, because I think I can sometimes see the nature of the game of life, and that game's role in the universe.
    `,
    },
    {
        title: 'Relax',
        youtube: '5RfqB76eHTQ',
        body: `
    A subconscious part of me wants to live here. This music also helps me focus sometimes. It slows my roll, but I'm scared to become too slow.
    `,
    },
    {
        title: 'S-Tier music video',
        youtube: 'blcaBZUOQwY',
        body: `
    A music video about a showman's personality manifeseted into a horse who becomes genocidal and tries to kill everything. If you like this also watch this <a href="https://www.youtube.com/watch?v=V_Hn6heZclA">https://www.youtube.com/watch?v=V_Hn6heZclA</a>. <br> <br> <b>"All the world's a stage"</b>
    `,
    },
    {
        title: 'Fighting to Flemanco',
        youtube: 'Tp5V4cqZUnE',
        body: `
    Starts at 1:56. Spanish flamenco + fighting animations are a rare combo. The stickfight people were known for their animation in the 2000s, so the fact that they'd get progressively better and into stuff like this is no surprise.
    `,
    },
    {
        title: 'Relax',
        youtube: '5Ea17DWcgN8',
        body: `
    A relaxing song called "fallen down", slowed and reverbed. Fitting, as you've scrolled down this far.
    `,
    },
    {
        title: 'Satanic rituals but with ponies',
        youtube: 'EryzJyRQMSg',
        body: `
    A song about two gods trying to convince their student to sacrifice the life of another so that they can avoid death and join them in godhood. I'm also posting this song because you're here to see rare shit and what's rarer than 5000 views?
    `,
    },
    {
        title: 'Music Submitted by TheHighFlys',
        youtube: 'SvlpvcqM9kQ',
        body: `
      Music submitted by TheHighFlys. I don't fully get it but I know it's high quality. Good mashup of animation and different musical themes. And I can say that whoever made this meant <i>something</i>. So I put it here for others and my future self to watch.
    `,
    },
    {
        title: '(For Guys) (1/2) Mad Hatter AMV',
        youtube: 'd3Iv1gscw5M',
        body: `
    (Part 1/2) Speaking of sins, I'm entitled to one set of anime trash.
    `,
    },
    {
        title: '(For Girls) (2/2) Mad Hatter AMV',
        youtube: 'OuiqolJoA_Y',
        body: `
    (Part 2/2) Speaking of sins, I'm entitled to one set of anime trash.
    `,
    },
    {
        title: 'Music Submitted by Unknown Person',
        youtube: 'Y0VfxCnP6_o',
        body: `
    Music submitted by an Unknown Person in 2023 with the message "Your status made me think of SPECIFICALLY this song, https://youtu.be/Y0VfxCnP6_o". My status at the time was the following: <a href="https://media.discordapp.net/attachments/325404076848316426/1425287374237339701/image.png?ex=68e709ce&is=68e5b84e&hm=087d1e34ef9d4a8674ee5b2718c71229c22209dbb8151da3ef828281dfe86979&=&format=webp&quality=lossless&width=1160&height=735" style="color: purple">Click here to see it</a>
    `,
    },
    {
        title: 'Only conspiracy theorists will understand',
        youtube: '1QCeS1XRqis',
        body: `
    I've never found mania so relatable.
    `,
    },
    {
        title: "Obsession of Revenge",
        youtube: 'Coa_OhboM30',
        body: `
    I know ponies can be cringe, but I like the animatic. Give it a shot. It's from the count of monte cristo - the story of a man who was falsely improsoned and had his wife (and likely wealth) stolen, so he obsesses himself to the revenge of those who plotted against him.
    `,
    },
    {
        title: "Heal",
        youtube: '8RMDBqQDtT8',
        body: `
    A song that kinda feels like it actually does heal you if you listen to it at the right time and with the right audio equipment.
    `,
    },
    {
        title: "Cute Cult Commune",
        youtube: '6ywXBNpc-To',
        body: `
    This guy does a lot of great music, but sort his youtube channel by popular, because this guy pumps out a LOT, and only a few of them are 🔥🔥🔥.
    My favorite are - (Bendy: Art of Darkness) - (If you like SCP: SLIDE INTO THE VOID) - (Cyberpunk: DATA STREAM) - (HITMAN: THE APEX) - And his frostpunk song
    `,
    },
    {
        title: "(for men) I want to die (in a War)",
        youtube: 'Si7dl6BU78E',
        body: `
    Only guys will get this.
    `,
    },
    {
        title: "Read The Description - All Adventure Time Songs (Marceline)",
        youtube: 'XIMLoLxmTDw',
        body: `
    I feel weird being a grown ass man and posting Rebecca Sugar songs, even though they're all S-tier, especially the Marceline ones. Seriously, I've never met a single person who hates her songs. So pretend I posted every adventure time song right here. I might be too old to post this shit, but I ought to pay homage to it.
    `,
    },
    {
        title: "Majestic vocal splice",
        youtube: 'uv8S2TOOzmw',
        body: `
    Posted 5 years ago with only 3k views, so this video is RARE. And you're here to see rare shit. If you wanted to see normal shit, you're free to go LITERALLY ANYWHERE ELSE ON THE INTERNET`,
    },
    {
        title: "Miku Lore",
        youtube: 'LocruwYJrGw',
        body: `
    Just posting things that are more normal for pages of this flavor. I don't want this entire page to be completely esoteric.
    `,
    },
    {
        title: "You literally cannot hate miku",
        youtube: 'xetSFt4BuFw',
        body: `
    You cannot hate Miku, but you can hate the man who posts Miku :)
    `,
    },
    {
        title: "Experimental Lunar Acoustic",
        youtube: 'CUXHp0U-QVg',
        body: `
    Tell me what u think about this one actually because idk, I used to hate it but now I kinda like it
    `,
    },
    {
        title: "2014 calm vibe music",
        youtube: 'FUuNXJxGBQU',
        body: `
    I used to listen to this on loop while studying. Calming and fitting, as it's called "mastering the art", and mastery often takes time, patience, and deliberate practice. The more I've craved the calm, the more I've liked a lot of songs from this artist.
    `,
    },
    {
        title: "2014 calm vibe music",
        youtube: 'joYewcet4_c',
        body: `
    12 years ago 10k views. Rare and calming, but anyone not a guy raised on 2012 dubsteppey music might not like the sounds.
    `,
    },
    {
        title: "Rare happy music",
        youtube: 'J5bhT4-9M0o',
        body: `
    If you know what I mean by "rare happy music", you know. This genre does not exist, so I'm putting this here to share for its rarity. Probably related to the previous video (Hooves Up High).
    
    `,
    },
    {
        title: "(1/3) Rises the moon - Anime Cover",
        youtube: '5b2MFJMeonI',
        body: `
        For Eastern cartoonists. A timeless elf watches her friends die with each rising sun.
    `,
    },
    {
        title: "(2/3) Rises the moon - BMO Cover",
        youtube: 'ZGfjynSDGsc',
        body: `For Western cartoonists. A timeless machine persists in their simplicity.`,
    },
    {
        title: "(3/3) Rises the moon - Fluttershy Cover",
        youtube: 'peeRHQHNIFw',
        body: `
        For the horse. A fellow mortal sings a comforting song for the present.
    `,
    },
    {
        title: "(1/2) - On Departure and Animals",
        youtube: '6tz4xJWbY9s',
        body: `
        The singer is 73 now. Wow. 
    `,
    },
    {
        title: "Music submitted by Box Monster",
        youtube: 'VtXTFi8edyE',
        body: `
        Music submitted by Box Monster 
    `,
    },
    {
        title: "Music Submission by random person",
        youtube: '6axOY4PBusk',
        body: `
       Submission by random person. They gave me 3 songs.
       https://www.youtube.com/watch?v=6axOY4PBusk
      https://www.youtube.com/watch?v=_TuEAuCH6ng
      https://www.youtube.com/watch?v=eFvtLhxmx9U
    `,
    },
    {
        title: "(2/2) - On Departure and Animals",
        youtube: 'gEhuGPXxRrA',
        body: `
        Both these songs are about departure in relationships and has an animal staring in your soul.
    `,
    },
    {
        title: "A motivation video before motivation videos were a thing",
        youtube: 'MT0lhDzQEh4',
        body: `
    2k views 7 years ago. 2018 was a different time. 7 goddamn years ago. Damn. 
    `,
    },
    {
        title: 'Music submitted by ArstotzkaThe3rd',
        youtube: 'YURockHD',
        body: `
    Music submitted by ArstotzkaThe3rd. Rare russian music. Nice.
    `,
    },
    {
        title: "The Realest AI Music Video",
        youtube: 'wCRftfx62uY',
        body: `
    The algorithm is to us what opiods are to millenials and smoking is to boomers. Be careful not to lose yourself to the internet and endless holes of stimulation, ok? Art is nice, but having these neurons fire in new and fun ways isn't the be all and end all of life. Or maybe it is. Idk. <br><br>
    `,
    },
];
function App() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header, null),
        react_1.default.createElement(Contact_1.default, null),
        react_1.default.createElement("div", { className: "break-words bg-color-background-default flex" },
            react_1.default.createElement("div", { className: "bg-slate-500 mx-auto p-3 gap-3 container grid grid-flow-row auto-rows-max grid-cols-1 md:grid-cols-2 lg:grid-cols-3 rounded-3xl" }, projects.map((post, index) => ( //@ts-ignore
            react_1.default.createElement(Project_1.default, { key: post.title + index, project: post, rank: index })))))));
}
exports.default = App;
